module.exports = __webpack_public_path__ + "static/media/F-AvvMbbMAA_Dlo.6d2fc556.webp";